import { motion } from 'framer-motion';
import { HeartPulse, CarFront, Umbrella, ArrowUpRight, Check } from 'lucide-react';
import { INSURANCE, preselectProduct } from '../data';

const ICONS = { HeartPulse, CarFront, Umbrella };

export const Insurance = () => (
    <section id="insurance" data-testid="insurance-section" className="py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            >
                <p className="font-mono-x text-xs uppercase tracking-[0.3em] text-emerald-400 mb-4">
                    06 — Protection Suite
                </p>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl">
                    Insurance Solutions.{' '}
                    <span className="text-slate-500">Alongside your loan, never instead of it.</span>
                </h2>
                <p className="mt-5 max-w-xl text-sm sm:text-base leading-relaxed text-slate-400">
                    Along with our loan services, we also help customers with suitable insurance
                    solutions for their health, vehicle, and life protection needs — same
                    concierge service, same single form.
                </p>
            </motion.div>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
                {INSURANCE.map((item, i) => {
                    const Icon = ICONS[item.icon];
                    return (
                        <motion.article
                            key={item.id}
                            data-testid={`insurance-card-${item.id}`}
                            initial={{ opacity: 0, y: 44 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-60px' }}
                            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
                            whileHover={{ scale: 1.02 }}
                            className="group relative rounded-2xl border border-white/10 bg-[#131924] p-7 flex flex-col hover:border-emerald-400/40 hover:shadow-[0_0_40px_rgba(16,185,129,0.12)] transition-[border-color,box-shadow] duration-300"
                        >
                            <div className="flex items-start justify-between">
                                <span className="w-11 h-11 rounded-xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center">
                                    <Icon className="w-5 h-5 text-emerald-400" />
                                </span>
                                <span className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-slate-500 text-right">
                                    cover <span className="text-emerald-400">{item.cover}</span>
                                </span>
                            </div>
                            <h3 className="mt-5 font-display text-xl sm:text-2xl font-semibold tracking-tight">
                                {item.title}
                            </h3>
                            <p className="mt-2 text-sm leading-relaxed text-slate-400">
                                {item.tagline}
                            </p>
                            <ul className="mt-5 space-y-2">
                                {item.features.map((f) => (
                                    <li key={f} className="flex items-center gap-2 text-xs text-slate-300">
                                        <Check className="w-3.5 h-3.5 text-emerald-400 shrink-0" />
                                        {f}
                                    </li>
                                ))}
                            </ul>
                            <a
                                href="#apply"
                                onClick={() => preselectProduct(item.value)}
                                data-testid={`insurance-apply-${item.id}`}
                                className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-400 group-hover:gap-2.5 transition-all duration-300"
                            >
                                Get a {item.title} Quote
                                <ArrowUpRight className="w-3.5 h-3.5" />
                            </a>
                        </motion.article>
                    );
                })}
            </div>
        </div>
    </section>
);
